import React, { useContext } from 'react';
import Faq from './Faq';
import ConfigContext from '../../../contexts/ConfigContext';

const getBreweriesFaqQuestions = (siteTitle, vehicleType) => [
  {
    question: `How do food ${vehicleType}s work at breweries and taprooms?`,
    answer: `A ${vehicleType} parks at your taproom on a set schedule and sells food to your customers. We build the rotation, handle scheduling, and keep you and the ${vehicleType}s in the loop, so you offer food without running a kitchen. Each ${vehicleType} arrives self-contained and leaves with nothing for your staff to clean up.`
  },
  // Pricing per the client (4 Sep 2026) and the 7 Sep owner decision: self-serve
  // through the catering form carries no program fee, hosted service is a
  // program fee quoted up front, and no price list is published. Same answer
  // as the page's "What it costs" card.
  {
    question: `Does it cost breweries anything to host food ${vehicleType}s?`,
    answer: `Most taprooms run this themselves: submit a recurring request through the catering form, pick your own ${vehicleType}s, and there's no program fee. Your customers buy their food at the ${vehicleType}, and any fee on the ${vehicleType}'s side is shown to them before they apply for the spot. Want us to run it instead? Hosted service is a monthly program fee we quote up front.`
  },
  {
    question: `How often can food ${vehicleType}s visit my brewery?`,
    answer: `As often as you want: daily, weekly, or on a rotation. Most taprooms keep a consistent schedule and change the cuisine so regulars have a reason to come back. We can adjust the lineup based on what your customers respond to.`
  },
  {
    question: `Do food ${vehicleType}s increase sales at breweries?`,
    answer: `We don't publish sales data, but the logic is simple: people who can eat stay for another round, and ${vehicleType}s bring their own followers who may not have visited otherwise. Many ${vehicleType}s post their schedule to their own customers.`
  },
  {
    question: `What types of food ${vehicleType}s are a good fit for breweries?`,
    answer: `Tacos, burgers, pizza, BBQ, Asian street food, and anything else that pairs with beer. We aim for a rotation with variety and ${vehicleType}s that show up when scheduled.`
  },
  {
    question: `What does my brewery need to host a food ${vehicleType}?`,
    answer: `A designated parking or setup area, roughly 30 ft by 8 ft. Most ${vehicleType}s bring their own power and water and won't need your kitchen or staff. If power, space, or permits come up, we'll sort it out with you before the first visit.`
  }
];

function BreweriesFaq() {
  const { site_title, vehicle_type } = useContext(ConfigContext);
  const vehicleType = vehicle_type.toLowerCase();

  const questions = getBreweriesFaqQuestions(site_title, vehicleType);

  return (
    <Faq questions={questions} />
  );
}

export default BreweriesFaq;
